import Video from '@components/Video';

export const ClosingSidebar = ({ hasClosings }) => {
  const noClosingsImageSrc = __ENVIRONMENT_CONFIG__.IS_THEME_AKI
    ? `${__ENVIRONMENT_CONFIG__.PUBLIC_URL}/assets/images/aaron-king/cube.png`
    : `${__ENVIRONMENT_CONFIG__.PUBLIC_URL}/assets/images/cube.png`;

  return (
    <div className="o-sidebar o-sidebar--y-center">
      {hasClosings ? (
        <Video video="cubes" sources={['webm']} />
      ) : (
        <img src={noClosingsImageSrc} alt="cube" />
      )}
    </div>
  );
};
